module.exports = __webpack_public_path__ + "img/button_sidebar.40f49d9e.png";